import React from "react";
import { getString } from "../../utilities";
import { useWidthSize } from "../../hooks";
import StaticCrown from "../../../assets/img/premiumCrown_lg.png";
import PremiumCrownSVG from "../../../assets/svg/premiumCrown.svg";

export default function PremiumCrown() {
  const animatedCrown = useWidthSize(["lg", "adsLG", "xl", "xxl"]);

  if (animatedCrown) {
    return <PremiumCrownSVG className="categoryprintables-title-premium catpr-premium" />;
  }

  return (
    <img
      src={StaticCrown}
      width="73"
      height="44"
      alt={getString("join.1")}
      className="categoryprintables-title-premium"
      style={{ height: "auto" }}
    />
  );
}
